import { useSatuEventTracker } from 'utils/satuEvent'
import { getSession } from 'utils/auth'

type ParamsTracker = Record<string, any>

interface ISeTrackMoeEngageEventProps {
  activityType: string
  deviceId: string
}

const DEFAULT_PARAMS_TRACKER = {
  source: 'untuk_anda',
}

const getUserId = () => {
  const session = getSession()
  return {
    user_id: session?.user?.id,
  }
}

const getUserData = () => {
  const session = getSession()
  return {
    user_id: session?.user?.id,
    user_email: session?.user?.email,
  }
}

const getUserAgent = () => {
  return {
    user_agent: navigator?.userAgent || '',
  }
}

export function useSETrackerEvent() {
  const { SETrackEvent } = useSatuEventTracker()

  const SETrackTopNav = (params?: ParamsTracker) => {
    SETrackEvent({
      eventName: 'microlearning_click_top_nav_v3',
      eventParams: {
        event_detail: {
          ...DEFAULT_PARAMS_TRACKER,
          ...params,
          ...getUserId(),
          ...getUserAgent(),
        },
      },
    })
  }

  const SETrackPromotionTopic = (params?: ParamsTracker) => {
    SETrackEvent({
      eventName: 'microlearning_click_promotion_topic_v3',
      eventParams: {
        event_detail: {
          ...DEFAULT_PARAMS_TRACKER,
          ...params,
          ...getUserId(),
          ...getUserAgent(),
        },
      },
    })
  }

  const SETrackRecommendationCollection = (params?: ParamsTracker) => {
    SETrackEvent({
      eventName: 'microlearning_click_theme_collection_v3',
      eventParams: {
        event_detail: {
          ...DEFAULT_PARAMS_TRACKER,
          ...params,
          ...getUserId(),
          ...getUserAgent(),
        },
      },
    })
  }

  const SETrackProgressTopic = (params?: ParamsTracker) => {
    SETrackEvent({
      eventName: 'microlearning_click_progress_topic_v3',
      eventParams: {
        event_detail: {
          ...DEFAULT_PARAMS_TRACKER,
          ...params,
          ...getUserId(),
          ...getUserAgent(),
        },
      },
    })
  }

  const SETrackWebinar = (params?: ParamsTracker) => {
    SETrackEvent({
      eventName: 'microlearning_click_webinar_v3',
      eventParams: {
        event_detail: {
          ...DEFAULT_PARAMS_TRACKER,
          ...params,
          ...getUserId(),
          ...getUserAgent(),
        },
      },
    })
  }

  const SETrackTopicList = (params?: ParamsTracker) => {
    SETrackEvent({
      eventName: 'microlearning_click_choose_topic_v2',
      eventParams: {
        event_detail: {
          ...params,
          ...getUserData(),
          ...getUserAgent(),
        },
      },
    })
  }

  const SETrackChooseOrder = (params?: ParamsTracker) => {
    SETrackEvent({
      eventName: 'microlearning_click_order_topic_v2',
      eventParams: {
        event_detail: {
          ...params,
          ...getUserData(),
          ...getUserAgent(),
        },
      },
    })
  }

  const SETrackMoEngageEvent = ({
    activityType,
    deviceId,
  }: ISeTrackMoeEngageEventProps) => {
    const session = getSession()

    SETrackEvent({
      eventName: 'guru_core_pwa_event_tracker_v1',
      eventParams: {
        activity_type: activityType,
        event_name: 'GURU_CORE_APP',
        device_id: deviceId,
        ...getUserId(),
        attributes: [
          {
            key: 'user_agent',
            value: { string_value: navigator?.userAgent || '' },
          },
          {
            key: 'teacher_email',
            value: { string_value: session?.user?.email },
          },
        ],
      },
    })
  }

  const SETrackSubmitAksiNyata = (params?: ParamsTracker) => {
    SETrackEvent({
      eventName: 'microlearning_click_submit_aksi_nyata_v2',
      eventParams: {
        event_detail: {
          ...params,
          ...getUserData(),
          ...getUserAgent(),
        },
      },
    })
  }

  return {
    SETrackTopNav,
    SETrackPromotionTopic,
    SETrackRecommendationCollection,
    SETrackProgressTopic,
    SETrackWebinar,
    SETrackTopicList,
    SETrackChooseOrder,
    SETrackMoEngageEvent,
    SETrackSubmitAksiNyata,
  }
}
